export const createJobsRoutes = (basePath: string) =>
  ({
    index: basePath,
    new: `${basePath}/new`,
    detail: (jobId: string) => `${basePath}/${jobId}`,
    detailPlan: (jobId: string) => `${basePath}/${jobId}/plan`,
    detailTasks: (jobId: string) => `${basePath}/${jobId}/tasks`,
    detailTimeline: (jobId: string) => `${basePath}/${jobId}/timeline`,
    detailChangeOrders: (jobId: string) => `${basePath}/${jobId}/change-orders`,
    detailChangeOrder: (jobId: string, changeOrderId: string) =>
      `${basePath}/${jobId}/change-orders/${changeOrderId}`,
    detailPerformance: (jobId: string) => `${basePath}/${jobId}/performance`,
    detailSettings: (jobId: string) => `${basePath}/${jobId}/settings`,
  }) as const;
